/*
 * NOTE: We want to maintain this component level template as a .ts file so we can add comments.
 */

export enum LegendPlacement {
  BOTTOM = 'bottom',
  RIGHT = 'right',
}

export default {
  name: 'dashify:Sunburst',
  title: 'Sunburst',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'sunburst', 'hierarchical'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'Oct 11, 2023, 03:32 PM',
  spec: {
    props: {
      highchartsConfig: {
        legend: {
          enabled: false,
        },
      },
      // Non Highcharts-related API
      customConfig: {
        legendPlacement: LegendPlacement.RIGHT,
        dataLabelsFormat: {
          valueOnly: false,
        },
      },
    },
    // Highcharts config for legend placement based on Particle
    legendPlacements: {
      bottom: {
        legend: {
          align: 'left',
          layout: 'horizontal',
          verticalAlign: 'bottom',
        },
      },
      right: {
        legend: {
          align: 'right',
          layout: 'vertical',
          verticalAlign: 'middle',
        },
      },
    },
    legendConfig: '/${ $lookup(legendPlacements, props.customConfig.legendPlacement) }',
    dataLabelsFormatDefault: '<div><span>{point.name}</span><span>&nbsp;(<b>{point.value:,0f}</b>)</span></div>',
    dataLabelsFormatValueOnly: '<div><span><b>{point.value:,0f}</b></span></div>',
    defaults: {
      series: [
        {
          type: 'sunburst',
          data: [],
          allowDrillToNode: true,
          cursor: 'pointer',
          borderWidth: 2,
          size: '100%',
          dataLabels: {
            format:
              '/${ props.customConfig.dataLabelsFormat.valueOnly ? dataLabelsFormatValueOnly : dataLabelsFormatDefault }',
            filter: {
              property: 'innerArcLength',
              operator: '>',
              value: 16,
            },
            style: {
              textOutline: 'none',
              fontFamily: 'var(--typography-font-body)',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '400',
              color: '#FFF',
            },
          },
          levels: [
            {
              level: 1,
              levelIsConstant: false,
              dataLabels: {
                rotationMode: 'parallel',
              },
              levelSize: {
                value: 5,
              },
            },
            {
              level: 2,
              colorByPoint: true,
              levelSize: {
                value: 8,
              },
            },
            {
              level: 3,
              colorVariation: {
                key: 'brightness',
                to: -0.5,
              },
              levelSize: {
                value: 10,
              },
            },
          ],
        },
      ],
      chart: {
        height: '100%',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'rgba(0,0,0,0)',
        style: {
          fontFamily: 'var(--typography-font-body)',
        },
        styledMode: false,
      },
      colors: [
        'var(--color-accent-a)',
        'var(--color-accent-b)',
        'var(--color-accent-c)',
        'var(--color-accent-d)',
        'var(--color-accent-e)',
        'var(--color-accent-f)',
        'var(--color-accent-g)',
        'var(--color-accent-h)',
        'var(--color-accent-i)',
        'var(--color-accent-j)',
      ],
      title: {
        style: {
          color: 'var(--color-default-text-strong)',
          fontFamily: 'var(--typography-font-body)',
          fontSize: '28px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 33,
          textShadow: false,
        },
        x: '/${ props.highchartsConfig.legend.enabled ? -80 : 0 }',
        verticalAlign: 'middle',
      },
      subtitle: {
        style: {
          color: '#FFF',
          fontFamily: 'var(--typography-font-body)',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: 19,
        },
        verticalAlign: 'middle',
      },
      tooltip: {
        enabled: false,
        valueDecimals: 0,
        useHTML: true,
        outside: true,
        backgroundColor: 'var(--color-default-bg)',
        style: {
          fontFamily: 'var(--typography-font-body)',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '400',
          color: 'var(--color-default-text)',
          backgroundColor: 'var(--color-default-bg)',
        },
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    },
    view: [['dashify:Highcharts', '/${ $defaultsDeep({}, legendConfig, props.highchartsConfig, defaults) }']],
  },
};
